module.exports = __webpack_public_path__ + "media/images/vp/icon.dropdown.white-abf504b478693bc52012cd61680e8417.svg";